import { render, staticRenderFns } from "./MoleculeRequestOffer.vue?vue&type=template&id=747ccf67&"
import script from "./MoleculeRequestOffer.vue?vue&type=script&lang=js&"
export * from "./MoleculeRequestOffer.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeRequestOffer.vue?vue&type=style&index=0&id=747ccf67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeRequestOffer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeRequestOffer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomSimpleButton: require('/app/components/atoms/common/AtomSimpleButton.vue').default,MoleculesProjectBuildingMoleculeSidebarResultSpaceDetails: require('/app/components/molecules/project/building/MoleculeSidebarResultSpaceDetails.vue').default,AtomsCommonAtomInput: require('/app/components/atoms/common/AtomInput.vue').default,AtomsCommonAtomRadio: require('/app/components/atoms/common/AtomRadio.vue').default,AtomsCommonAtomCheck: require('/app/components/atoms/common/AtomCheck.vue').default})
